import { BASE_URL } from './index'

export const companyData = (aviso, settingsCompanyURL) => {
  const data = {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name: aviso?.empresa?.denominacion || 'Confidencial',
    image: aviso?.empresa?.logoURL,
    '@id': aviso?.empresa?.id?.toString(),
    url: '',
    address: {
      '@type': 'PostalAddress',
      addressLocality: aviso?.localizacion?.localidadDetalle,
      addressCountry: aviso?.localizacion?.paisDetalle,
    },
  }

  if (settingsCompanyURL) {
    data.url = `${BASE_URL}${settingsCompanyURL?.href || settingsCompanyURL?.link}`
  }

  return JSON.stringify(data)
}
